export default __webpack_public_path__ + "static/media/audi.c5a46d8a.webp";